import { ApiResponse } from "../../types/admin";
import httpClient from "../httpClient";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5152/api";

export interface ResumeInfo {
  id: number;
  fileNamePtBr: string;
  sizePtBr: number;
  urlPtBr: string;
  fileNameEnUs: string;
  sizeEnUs: number;
  urlEnUs: string;
  updatedAt: string;
}

const downloadBlobInternal = async (language: "pt-br" | "en-us"): Promise<Blob | null> => {
  const token = localStorage.getItem("admin_token");
  try {
    const response = await fetch(
      `${API_BASE_URL}/resume/download/${language}`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    if (!response.ok) return null;
    return await response.blob();
  } catch {
    return null;
  }
};

export const resumeApi = {
  getInfo: (): Promise<ApiResponse<ResumeInfo>> =>
    httpClient.get("/resume"),

  /** POST /api/resume/upload — both fields required.
   *  When uploading one language, auto-fetches the other from server. */
  upload: async (
    filePtBr?: File | null,
    fileEnUs?: File | null
  ): Promise<ApiResponse<unknown>> => {
    const formData = new FormData();

    if (filePtBr && !fileEnUs) {
      const existingEn = await downloadBlobInternal("en-us");
      formData.append("FilePtBr", filePtBr);
      if (existingEn && existingEn.size > 0) {
        formData.append("FileEnUs", existingEn, "resume-en.pdf");
      } else {
        formData.append("FileEnUs", filePtBr);
      }
    } else if (fileEnUs && !filePtBr) {
      const existingPt = await downloadBlobInternal("pt-br");
      formData.append("FileEnUs", fileEnUs);
      if (existingPt && existingPt.size > 0) {
        formData.append("FilePtBr", existingPt, "resume-pt.pdf");
      } else {
        formData.append("FilePtBr", fileEnUs);
      }
    } else if (filePtBr && fileEnUs) {
      formData.append("FilePtBr", filePtBr);
      formData.append("FileEnUs", fileEnUs);
    }

    return httpClient.postFormData("/resume/upload", formData);
  },

  getDownloadUrl: (language: "pt-br" | "en-us"): string =>
    `${API_BASE_URL}/resume/download/${language}`,

  downloadBlob: downloadBlobInternal,
};
